
<template>

    <div id="CameraApp">

        <div class="cameraApp-content">

            <div class="visual-editor">

                <video class="editor-video" :class="cameraFront" autoplay playsinline></video>
                <canvas class="editor-canvas" ></canvas>

                <img class="editor-silueta" :src="producto.url_silueta"/>
            
            </div>

        </div>
        
        <div class="circle-btn" @click="changeCamera" ><img :src="baseURL+'/modules/supercheckout/images/'+nameIconCamera+'.png'" ></div>
        <div class="circle-btn right" @click="captureImg" ><img :src="baseURL+'/modules/supercheckout/images/camara.png'" ></div>

    </div>

</template>


<script>


export default {

    props: ['producto'],

    data(){
        return {
            title: 'categorias',
            nameIconCamera: 'camara-trasera',
            mediaStream: null,
            baseURL,
            deviceIds: [],
            deviceIndex: 'user'
        }
    },

    computed: {

        cameraFront: function(){

            if( this.deviceIndex == 'user' ){

                return 'front'

            }

            return ''

        }

    },

    mounted: function () {

        const _this = this

        const editorVideo = $('.editor-video')

        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {

            navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                devices.forEach(function(device) {

                    if(device.kind == 'videoinput'){

                            console.log(device.kind + ": " + device.label + " id = " + device.deviceId)

                            _this.deviceIds.push(device.deviceId)

                    }

                })

                // navigator.mediaDevices.getUserMedia({ video: { deviceId: _this.deviceIds[_this.deviceIndex] } }).then(function(stream) {

                //     _this.mediaStream = stream
                //     editorVideo[0].src = window.URL.createObjectURL(stream);
                //     // editorVideo[0].play()

                // })

                console.log('1 device', _this.deviceIds)
                console.log('1 Index', _this.deviceIndex)

                const constraints = {
                    video: { facingMode: _this.deviceIndex }
                };

                const video = document.querySelector('video');

                function handleSuccess(stream) {
                    _this.mediaStream = stream
                    window.stream = stream; 
                    video.srcObject = stream;
                }

                navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess)

            })
            .catch(function(err) {
                console.log(err.name + ": " + err.message);
            });

        }
     
    },

    methods: {

        changeCamera: function(){

            const editorVideo = $('.editor-video')

            const _this = this

            if( _this.deviceIndex == 'user'){
                _this.deviceIndex = 'environment'
            }else{
                _this.deviceIndex = 'user'
            }

            if (_this.mediaStream) {
                _this.mediaStream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }

            //  navigator.mediaDevices.getUserMedia({ video: { deviceId: {exact: _this.deviceIds[_this.deviceIndex] } } }).then(function(stream) {

            //     _this.mediaStream = stream
            //     editorVideo[0].src = window.URL.createObjectURL(stream);
            //     // editorVideo[0].play()

            // })

            console.log('2 device', _this.deviceIds)
            console.log('2 Index', _this.deviceIndex)

            const constraints = {
                video: { facingMode: _this.deviceIndex }
            };

            const video = document.querySelector('video');

            function handleSuccess(stream) {
                _this.mediaStream = stream
                window.stream = stream; 
                video.srcObject = stream;
            }

            navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess)

            // console.log(this.deviceIds[this.deviceIndex])

        },

        captureImg: function(){

            const editorVideo = $('.editor-video')
            const editorCanvas = $('.editor-canvas')
            const editorSilueta = $('.editor-silueta')

            var siluetaWidthEquivalente = ( editorVideo[0].videoWidth * editorSilueta.width() ) / editorVideo.width()

            var centerCalc = ( editorVideo[0].videoWidth - siluetaWidthEquivalente ) / 2
            
            // Tamaño de Canvas
            editorCanvas[0].width = editorSilueta.width() // ancho 
            editorCanvas[0].height = editorSilueta.height() // alto

            // Espacio Izquerda - Arriba
            var sourceX = centerCalc; 
            var sourceY = 0;

            // Tamaño real del elemento a fotografiar
            var sourceWidth = editorVideo[0].videoWidth;
            var sourceHeight = editorVideo[0].videoHeight;

            // Tamaño del elemento tras meterle css
            var destWidth = editorVideo.width();
            var destHeight = editorSilueta.height();

            var destX = 0
            var destY = 0
           
            editorCanvas[0].getContext('2d').drawImage(editorVideo[0], sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight)
		
			this.mediaStream.getTracks().forEach(function(track){track.stop()})
            editorVideo[0].src = ""

            $('.visual-editor').width( editorSilueta.width() )

            editorSilueta.css('visibility', 'hidden')
			editorVideo.hide()
            editorCanvas.show()

            this.$emit('on-imgCapture', editorCanvas[0].toDataURL() )

        }

    }

}

</script>



<style lang="scss">

    #CameraApp{
        margin: 20px auto;
        max-width: 1200px;
        position: relative;

        .cameraApp-content{
            box-shadow: 0 3px 6px rgba(0,0,0,.16), 0 3px 6px rgba(0,0,0,.23);
            overflow: hidden;
            display: grid;
        }

        .visual-editor{
            position: relative;
            height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

             img{
                height: 100%;
                z-index: 1;
                // border: solid 1px;
            }
        }

        video{
            position: absolute;
            height: 100%;
        }

        video.front{
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
        }

        .editor-canvas {
            position: absolute;
            height: 100%;
        }

        .circle-btn{
            position: absolute;
            z-index: 10;
            bottom: 0;
            margin: 10px;

            width: 75px;
            height: 75px;

            img{
                width: 90%;
            }

        }

        .circle-btn.right{
            right: 0;
        }
      
    }



</style>



// WEBPACK FOOTER //
// src/components/CameraApp.vue